import { Injectable } from '@angular/core';
import { FeatureToggleModele } from '../../../core/modeles/feature-toggle.modele';
import { TypeProjet } from '../../../shared/constants/type-projet.enum';
import { AppConfigService } from '../../../app-config.service';
import { BaseCondition } from '../../conditions/base-condition';
import { coerceArray } from '@angular/cdk/coercion';
import { Store } from '@ngxs/store';
import { ProvinceEnum } from 'src/app/shared/constants/province.enum';

@Injectable({
  providedIn: 'root'
})
export class FeatureDecisionService {
  constructor(private readonly _appConfigService: AppConfigService, private readonly _store: Store) {}

  get typeProjet(): TypeProjet {
    return this._appConfigService.typeProjet;
  }

  get features(): Array<FeatureToggleModele> {
    return this._appConfigService.configData.toggles;
  }

  get province(): ProvinceEnum {
    return this._appConfigService.province;
  }

  selectSnapshot(selector: any) {
    return this._store.selectSnapshot(selector);
  }

  evaluate(filters: BaseCondition | Array<BaseCondition>): boolean {
    return coerceArray(filters).every(filter => filter.isAllowed(this));
  }
}
